module.exports = __webpack_public_path__ + "img/BJ.d0516ea5.svg";